import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { Field, FieldArray } from 'redux-form'

import { map } from 'lodash'
import { translate } from 'parking-react-common'

import { ui, parkingLots } from '../redux'

import Panel from '../components/Panel'
import FormContainer from '../components/FormContainer'
import { Column } from '../components/Grid'
import DatePickerInput from '../components/DatePickerInput'
import Button from '../components/Button'
import WeeklyTimetableListForm from '../components/WeeklyTimetableListForm'

const SchedulesListForm = (props) => {
    const { fields, type, withPricing, t } = props
    const isCustomSchedule = type === parkingLots.SCHEDULE_TYPES.customSchedule
    const isWeeklySchedule = type === parkingLots.SCHEDULE_TYPES.weeklyTimetable

    if (isCustomSchedule) {
        return (
            <Fragment>
                { map(fields, (schedule, index) => (
                    <Panel
                        title={ t('Schedule #{{number}}', { number: index + 1 }) }
                        key={ index }
                        tools={ (
                            <Fragment>
                                <FormContainer isHorizontal>
                                    <Column span={ 5 }>
                                        <Field
                                            name={ `${fields.name}[${index}].start_date` }
                                            component={ DatePickerInput }
                                            size={ ui.SIZE.small }
                                        />
                                    </Column>
                                    <Column span={ 5 }>
                                        <Field
                                            name={ `${fields.name}[${index}].stop_date` }
                                            component={ DatePickerInput }
                                            size={ ui.SIZE.small }
                                        />
                                    </Column>
                                </FormContainer>
                                <Button
                                    onClick={ () => fields.remove(index) }
                                    intent={ ui.INTENT.danger }
                                    icon="md/delete"
                                    isRounded
                                />
                            </Fragment>
                        ) }
                        withDivider
                        hasTable
                    >
                        <FieldArray
                            name={ `${fields.name}[${index}].week_timetables` }
                            component={ WeeklyTimetableListForm }
                            isHidden={ !isCustomSchedule && !isWeeklySchedule }
                            withPricing={ withPricing }
                        />
                    </Panel>
                )) }
                <Panel
                    tools={ (
                        <Button
                            size={ ui.SIZE.large }
                            onClick={ () => fields.push(parkingLots.createSchedule()) }
                            intent={ ui.INTENT.primary }
                            icon="md/add"
                            label={ t('Add a Schedule') }
                            isRounded
                        />
                    ) }
                />
            </Fragment>
        )
    }

    return (
        <Panel title={ t('Weekly Schedule') } withDivider hasTable>
            <FieldArray
                name={ `${fields.name}[0].week_timetables` }
                component={ WeeklyTimetableListForm }
                isHidden={ !isCustomSchedule && !isWeeklySchedule }
                withPricing={ withPricing }
            />
        </Panel>
    )
}

SchedulesListForm.propTypes = {
    fields      : PropTypes.object.isRequired,
    type        : PropTypes.string,
    withPricing : PropTypes.bool
}

SchedulesListForm.defaultProps = {
    withPricing: true
}

export default translate()(SchedulesListForm)
